
import {defineComponent, ref, reactive, toRefs, inject , onMounted} from "vue";
import {ErrorMessage, Field, Form} from "vee-validate";
import {Actions} from "@/store/enums/StoreEnums";
import {useStore} from "vuex";
import {useRouter,useRoute} from "vue-router";
import {useI18n} from 'vue-i18n';
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import AOS from "aos";

export default defineComponent({
  name: "sign-in",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  setup() {
    const helpers: any = inject("helpers");
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const i18n = useI18n();
    const {t} = useI18n();


    onMounted(() => {
      AOS.init();
    });


    const state = reactive({
      email: null,
    });

    const submitButton = ref<HTMLElement | null>(null);

    //Form submit function
    const onSubmitLogin = (values, form) => {
      // Clear existing errors
      store.dispatch("moduleAuth/logout");

      if (!form) {
        return;
      }

      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        submitButton.value.setAttribute("disabled", "true");
      }

      const {setErrors} = form;

      // Dummy delay
      setTimeout(() => {
        // Send login request
        let payload = {
          "email": state.email,
        };
        store
          .dispatch("moduleAuth/forgetPassword", payload)
          .then((response) => {
            helpers.successNotify(t("success"), t("success_msg"));

            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          })
          .catch((response) => {
            if (!helpers) {
              return
            }
            helpers.handleResponse(response, t, router, store, {setErrors});
            //Deactivate indicator
            submitButton.value?.removeAttribute("data-kt-indicator");
            submitButton.value?.removeAttribute("disabled");
          });

      }, 100);
    };

    return {
      ...toRefs(state),
      onSubmitLogin,
      submitButton,
    };
  },
});
